<template>
  <div class="m-l-50 m-t-30 w-800">
    <el-form ref="form" :model="form" :rules="rules" label-width="130px">
      <el-form-item label="问题" prop="name">
        <el-input v-model.trim="form.name" class="h-40 w-400"></el-input>
      </el-form-item>
      <el-form-item label="解决方案" prop="value">
        <SquillEditorQiniu :token='qiniuForm.token' v-model="form.value" :content="form.value" :domain='qiniuForm.domain' :uploadUrl='uploadUrl'></SquillEditorQiniu>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="add()" :loading="isLoading" size="small">提 交</el-button>
        <el-button @click="goback()" size="small">返 回</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<style>
  .form-checkbox:first-child{
    margin-left: 15px;
  }
  
</style>
<script>
  import http from '../../../../assets/js/http'
  import fomrMixin from '../../../../assets/js/form_com'
  import SquillEditorQiniu from '../../../Common/squill-editor-qiniu.vue'

  export default {
    data() {
      return {
        isLoading: false,
        form: {
          name: '',
          value: '',
        },
        qiniuForm: {
          token: '',
          domain: window.HOST + 'qiniu'
        },
        editorOption:{},
        rules: {
          name: [
            { required: true, message: '请填写问题' }
          ],
          value: [
            { required: true, message: '请输入解决方案' }
          ]
        }
      }
    },
    methods: {
      onEditorBlur(){//失去焦点事件
      },
      onEditorFocus(){//获得焦点事件
      },
      onEditorChange(){//内容改变事件
      },
      add() {
        this.$refs.form.validate((pass) => {
          if (pass) {
            this.isLoading = !this.isLoading
            this.apiPut('admin/robot/', this.id, this.form).then((res) => {
              this.handelResponse(res, (data) => {
                _g.toastMsg('success', '保存成功')
                _g.clearVuex('setUsers')
                setTimeout(() => {
                  this.goback()
                }, 1500)
              }, () => {
                this.isLoading = !this.isLoading
              })
            })
          }
        })
      },
      async getCompleteData() {
        this.apiGet('admin/robot/' + this.id).then((res) => {
          this.handelResponse(res, (data) => {
            console.log(data)
            this.form.name = data.name
            this.form.value = data.value
          })
        })
      }
    },
    created() {
      this.id = this.$route.params.id
      this.getCompleteData()
    },
    components: {
      SquillEditorQiniu
    },
    mixins: [http, fomrMixin]
  }
</script>


// WEBPACK FOOTER //
// edit.vue?5987b022